import { replaceSearchString } from 'actions/NavigationActions'
import { fetchChats } from 'actions/supportAssistant/supportAssistantActions'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { sortBy } from 'lib/array/arrayUtils'
import { haveOrdersBeenFetched } from 'lib/order/orderUtils'
import { useEffect, useMemo } from 'react'
import { useLocation } from 'react-router'
import { getUpcomingOrders } from 'selectors/orderSelectors'
import { selectLoggedIn } from 'selectors/accountSelectors'

export const DEFAULT_CHAT: App.Chat = {
  id: 'default',
  title: 'New chat',
  status: 'ACTIVE',
  createdAt: new Date().toString(),
  updatedAt: new Date().toString(),
}

export const emptyChat: App.SupportAssistantChatsState = {
  chats: [DEFAULT_CHAT],
  fetching: false,
  error: undefined,
}

function useChats(): [Array<App.Chat>, boolean | undefined, any] {
  const dispatch = useAppDispatch()
  const chats = useAppSelector(state => state.supportAssistant.chats)
  const ordersFetched = useAppSelector(state => haveOrdersBeenFetched(state, 'upcoming'))
  const upcoming = useAppSelector(state => getUpcomingOrders(state))
  const loggedIn = useAppSelector(selectLoggedIn)

  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const chatDeepLink = queryParams.get('list-orders') === 'true' ? 'list-orders' : 'none'
  const chatDeepLinkKey: App.ChatDeepLinks = chatDeepLink

  const realChats = chats && chats.chats?.length > 0 ? chats : emptyChat

  const sortedRealChats = useMemo(() => {
    const sortedChats = sortBy(realChats.chats, chat => +(new Date(chat.updatedAt)), 'desc')

    return sortedChats
  }, [realChats.chats])

  useEffect(() => {
    if (ordersFetched) {
      dispatch(fetchChats(upcoming, chatDeepLinkKey))
    }

    dispatch(replaceSearchString({ 'list-orders': undefined }))
  }, [chatDeepLinkKey, dispatch, loggedIn, ordersFetched, upcoming])

  return [
    sortedRealChats,
    realChats.fetching,
    realChats.error,
  ]
}

export default useChats
